import React from 'react';
import { Tag } from 'antd';
import {
  ClockCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  DollarCircleOutlined,
  EditOutlined,
  StopOutlined,
} from '@ant-design/icons';

export const CLAIM_STATUS_MAP: Record<
  string,
  { label: string; color: string; icon: React.ReactNode }
> = {
  DRAFT: { label: 'Nháp', color: 'default', icon: <EditOutlined /> },
  SUBMITTED: { label: 'Chờ L1 duyệt', color: 'processing', icon: <ClockCircleOutlined /> },
  APPROVED_BY_APPROVER: {
    label: 'Đã duyệt L1 (Chờ Finance)',
    color: 'warning',
    icon: <ClockCircleOutlined />,
  },
  REJECTED_BY_APPROVER: { label: 'L1 Từ chối', color: 'error', icon: <CloseCircleOutlined /> },
  APPROVED_BY_FINANCE: {
    label: 'Đã duyệt L2 (Chờ TT)',
    color: 'purple',
    icon: <CheckCircleOutlined />,
  },
  REJECTED_BY_FINANCE: { label: 'L2 Từ chối', color: 'error', icon: <CloseCircleOutlined /> },
  PAID: { label: 'Đã thanh toán', color: 'success', icon: <DollarCircleOutlined /> },
  CANCELLED: { label: 'Đã hủy', color: 'default', icon: <StopOutlined /> },
};

interface ClaimStatusTagProps {
  status: string;
}

export const ClaimStatusTag: React.FC<ClaimStatusTagProps> = ({ status }) => {
  const info = CLAIM_STATUS_MAP[status] || { label: status, color: 'default', icon: null };
  return (
    <Tag color={info.color} icon={info.icon} style={{ borderRadius: 4, padding: '2px 8px' }}>
      {info.label}
    </Tag>
  );
};

export default ClaimStatusTag;
